import { useRouter } from 'next/router';

import { isOk } from 'domains/Result';
import { fireToast } from 'helpers/Toasts';
import { useAuthOptions } from 'hooks/useAuthOptions';
import { orderRepository } from 'repositories/Order/OrderRepository';
import type { useHistoryCheckModalProps } from 'components/Toolkit/HistoryCheckModal/HistoryCheckModal.typed';
import { useUserContext } from 'contexts/UserContext';
import { HISTORY_CHECK_REPORT } from 'components/Toolkit/HistoryCheckModal/HistoryCheckModal.typed';
import { formatAuthorizationHeader } from 'helpers/auth';

const useHistoryCheckModal = (props: useHistoryCheckModalProps) => {
  const { adId, callbackUrl } = props;
  const { accessToken, handleLogin } = useAuthOptions();
  const router = useRouter();
  const { user } = useUserContext();

  const handleOrderHistoryReport = async () => {
    if (!user) {
      handleLogin(callbackUrl);
      return;
    }

    const historyReport = await orderRepository.historyReport(
      { type: HISTORY_CHECK_REPORT.COMPLETE_REPORT, param: adId },
      formatAuthorizationHeader(accessToken),
    );

    if (isOk(historyReport)) {
      const orderID = historyReport.ok.id;
      router.push(`/order/${orderID}`);
    } else {
      fireToast({
        type: 'ERROR',
        text: 'Oops! Something went wrong, please try again later.',
      });
    }
  };

  return {
    handleOrderHistoryReport,
  };
};

export default useHistoryCheckModal;
